import { Button, Segmented, Table, TableProps } from 'antd';
import { useEffect, useState } from 'react';

import styles from './billing-history.module.scss';
import dayjs from 'dayjs';
import NoData from 'components/noData/noData';

interface BillingHistory {
	key: number;
	date: Date;
	description: string;
	amount: number;
	invoice: string;
	action: string;
}

function ProfileBillingHistoryComponent() {
	const [data, setData] = useState<BillingHistory[]>([
		{
			key: 1,
			date: new Date(),
			description: 'Invoice for October 2023',
			amount: 89.58,
			invoice: '#',
			action: '#',
		},
		{
			key: 2,
			date: new Date(),
			description: 'Invoice for October 2023',
			amount: 9.58,
			invoice: '#',
			action: '#',
		},
		{
			key: 3,
			date: new Date(),
			description: 'Invoice for October 2023',
			amount: 25.05,
			invoice: '#',
			action: '#',
		},
		{
			key: 4,
			date: new Date(),
			description: 'Invoice for October 2023',
			amount: 82.38,
			invoice: '#',
			action: '#',
		},
		{
			key: 5,
			date: new Date(),
			description: 'Invoice for October 2023',
			amount: 120.25,
			invoice: '#',
			action: '#',
		},
	]);

	const columns: TableProps<BillingHistory>['columns'] = [
		{
			title: 'Date',
			dataIndex: 'date',
			key: 'date',
			render: (date) => <span style={{ color: '#a5a5a5', fontWeight: 500 }}>{dayjs(date).format('MMM DD,yy')}</span>,
		},
		{
			title: 'Description',
			dataIndex: 'description',
			key: 'description',
			render: (description) => <span style={{ color: '#3E97FF' }}>{description}</span>,
		},
		{
			title: 'Amount',
			dataIndex: 'amount',
			key: 'amount',
			render: (amount) => <span style={{ color: '#a5a5a5', fontWeight: 500 }}>{amount}$</span>,
		},
		{
			title: 'Invoice',
			dataIndex: 'invoice',
			key: 'invoice',
			render: (invoice) => <Button className="discard small">PDF</Button>,
		},
		{
			title: '',
			dataIndex: 'action',
			key: 'action',
			render: (action) => <Button className="discard small">View</Button>,
		},
	];

	return (
		<>
			<div className="sectionContainer titled">
				<header className="d-flex justify-content-between align-items-center">
					Billing History
					<Segmented<string>
						options={['Month', 'Year', 'All time']}
						onChange={(value) => {
							console.log(value);
						}}
					/>
				</header>
				<main>
					<div className="d-flex justify-content-end"></div>

					<Table columns={columns} dataSource={data} scroll={{ x: 600 }} key="key"  
							locale={{ emptyText: <NoData /> }}
							/>
				</main>
			</div>
		</>
	);
}

export default ProfileBillingHistoryComponent;
